<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-6 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>Buy credits</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-hover">
              <thead>
                <tr>
                  <td class="col-md-1">Number</td>
                  <td>Product</td>
                  <td>Credits</td>
                  <td v-if="customer.vat_reversed !== 1">VAT</td>
                  <td v-else></td>
                  <td>Price</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="product in productList">
                  <td>
                    <input type="number" min="1" max="100" :name="'productSelect_' + product.id" @input="productChanged($event, product.id, product.amount, product.vat)">
                  </td>
                  <td>
                    <label>
                      {{ product.short_name }} | {{ product.long_name }}
                    </label>
                  </td>
                  <td>{{product.credits}}</td>
                  <td v-if="customer.vat_reversed !== 1">{{product.vat}} %</td>
                  <td v-else></td>
                  <td>{{product.amount | currency}}</td>
                </tr>
                <tr class="column-title">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{this.withoutVatTotal|currency}}</strong></td>
                </tr>
                <tr v-if="customer.vat_reversed !== 1">
                  <td>
                    <strong>
                      VAT
                      <span v-if="this.vatPercentage">({{ this.vatPercentage }}%)</span>:
                    </strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{this.vatAmount|currency}}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Total:</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{this.calculatedAmount|currency}}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="clearfix"></div>
            <button
              type="button"
              :disabled="disableBuyButton"
              class="btn btn-block btn-success"
              @click="buy()"
            >
              <i class="fas fa-arrow-alt-circle-right"></i> Buy credits
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>Your details</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-hover">
              <thead>
                <tr>
                  <td>Field</td>
                  <td>value</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Your customer ID</th>
                  <td>{{ customer.id }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Name</th>
                  <td>{{ customer.first_name }} {{ customer.last_name }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Address</th>
                  <td>{{ customer.address_1 }} {{ customer.address_2 }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">ZIPcode & City</th>
                  <td>{{ customer.zipcode }} {{ customer.city }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Current credits</th>
                  <td>{{ customer.credits }}</td>
                  <td></td>
                </tr>
                <tr v-if="customer.vat_reversed === 1">
                  <th scope="row">VAT Reverse charge?</th>
                  <td>YES</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: function() {
    return {
      disableBuyButton: false,
      productList: {},
      selectedProduct: {},
      selectedProducts: {},
      calculatedAmount: 0,
      vatAmount: 0,
      withoutVatTotal: 0,
      creditPrice: 0,
      creditPriceFormatted: 0,
      vatAmountFormatted: 0,
      creditPriceInclVAT: 0,
      vatPercentage: 0,
      customer: {}
    };
  },
  mounted: function() {
    this.loadProducts();
    Webservice.getUser().then(resp => {
      this.customer = resp.data;
    });
  },
  methods: {
    productChanged(event, productId, productPrice, productVat) {
      this.selectedProducts[productId] = {
        id: productId,
        price: productPrice,
        vat: productVat,
        number: event.target.value,
      }
      this.calcTotal();
      return;
    },

    calcTotal() {
      let calcAmount = 0; let calcVatAmount = 0;

      _.forEach(this.selectedProducts, (productItem) => {
        calcAmount += productItem.price * productItem.number;
        calcVatAmount += parseFloat(((productItem.price * productItem.number) * productItem.vat) / 100);
      });

      let productAmount = accounting.toFixed(calcAmount);
      let productVat =
        null != this.selectedProduct.vat
          ? parseFloat(this.selectedProduct.vat)
          : 0;
      let vatAmount = calcVatAmount; 
      let total = 0; let withoutVatTotal = 0;
      if (this.customer.vat_reversed === 0) {
        let multiplier = productVat * 100;
        withoutVatTotal = parseFloat(productAmount);
        total = parseFloat(productAmount) + parseFloat(vatAmount)//  accounting.toFixed((vatAmount + productAmount));
        this.vatPercentage = productVat;
        this.vatAmount = vatAmount;
      } else {
        total = productAmount;
      }
      this.withoutVatTotal = withoutVatTotal;
      this.calculatedAmount = total;
    },
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    loadProducts() {
      Webservice.getProducts("credits").then(response => {
        this.productList = response.data;
      });
    },
    buy() {
      if (this.selectedProduct.id || this.selectedProducts) {
        this.disableBuyButton = true;
        this.transactionProcessing = true;
        Webservice.createPayment(this.selectedProduct.id, this.selectedProducts)
          .then((resp) => {
              var buyWindow = resp.data.redir_url;
              if (
                typeof buyWindow === "undefined" ||
                _.includes(resp.data,"failed")
              ) {
                swal(
                  "Whoops",
                  "The payment failed due to an unknown error. Please contact your support team for more help. Also, please check the payment status page if possible.<br/><small>" + resp.data + '</small>',
                  "warning"
                );
                this.transactionProcessing = false;
              } else {
                window.location.href = buyWindow;

                swal({
                  title: "Please wait",
                  type: "info",
                  html:
                    'Your browser is being redirected to our payment provider. Please stand by or <a href="' +
                    buyWindow +
                    '">click here</a>',
                  showCloseButton: true,
                  focusConfirm: false
                });
                this.ticketData = null;
              }
            }
          )
          .catch(
            function(error) {
              console.log(error)
              if (_.includes(error.response.data, "Error 010")) {
                swal(
                  "Whoops",
                  "An error occured. You are an EU entity but your VAT number is not valid or you didn't enter it. Go to your profile and update your details please. Afterwards you can continue with the payment process.",
                  "warning"
                );
              }
              swal(
                "Whoops",
                "The payment failed due to an unknown error. Please contact your support team for more help. Also, please check the payment status page if possible.<br/><small>" + error.response.data + '</small>',
                "warning"
              );
              this.buyBtnDisabled = false;
              this.transactionProcessing = false;
            }.bind(this)
          );
      } else {
        this.$notify({
          component: {
            template: `<span>No credits selected. Please select some to continue.</span>`
          },
          icon: "fas fa-exclamation-triangle",
          type: "danger"
        });
      }
    }
  },
  computed: {
    ws: () => Webservice
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/buycredit.vue